import { Award, Star, Shield, Clock } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export function TrustSection() {
  const { t } = useLanguage();

  const stats = [
    { icon: Clock, valueKey: "trust.experience_value", labelKey: "trust.experience_label" },
    { icon: Star, valueKey: "trust.reviews_value", labelKey: "trust.reviews_label" },
    { icon: Shield, valueKey: "trust.complaints_value", labelKey: "trust.complaints_label" },
    { icon: Award, valueKey: "trust.documents_value", labelKey: "trust.documents_label" },
  ];

  return (
    <section className="py-20 bg-card border-y border-border">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center group"
            >
              <div className="inline-flex items-center justify-center w-16 h-16 bg-secondary/10 rounded-2xl mb-4 group-hover:bg-secondary/20 transition-colors">
                <stat.icon className="w-8 h-8 text-secondary" />
              </div>
              <div className="font-display font-bold text-3xl md:text-4xl text-foreground mb-2">
                {t(stat.valueKey)}
              </div>
              <div className="text-muted-foreground font-medium">
                {t(stat.labelKey)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
